<template>
<div style="position:absolute;z-index:101;width:100%;pointer-events: none;" class="pa-4" v-if="package.settings != null">
     <v-navigation-drawer
        floating
        permanent
        v-if="package.settings.stageViewer == true"
      >
        <v-row no-gutters="" class="pa-1">
          <v-col class="text-center" cols="auto">
            <div style="padding: 10px">
            {{currentStage.name}}
            </div>
          </v-col>
          <v-spacer>
          </v-spacer>
          <v-btn icon="" large v-on:click="GoLeft()">
            <v-icon>
              mdi-arrow-left-bold-circle
            </v-icon>
          </v-btn>

          <v-btn icon="" large v-on:click="GoRight()">
            <v-icon>
              mdi-arrow-right-bold-circle
            </v-icon>
          </v-btn>
        </v-row>
        <v-list
          dense
          rounded
          v-model="listModel"
        >
          <v-list-group
            group="upper"
            >
              <template v-slot:activator>
                <v-list-item-title>Stages</v-list-item-title>
              </template>
              <v-list-group
                group="lower"
                no-action
                sub-group
                v-for="(stage,i) in package.stages" :key="i"
              >
             
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title :style="(stage.id == currentStage.id) ? 'color:blue' : ''">{{stage.name}}</v-list-item-title>
                  </v-list-item-content>
                  <v-btn v-on:click.stop="GoToStage(stage)" icon>
                    <v-icon>
                      mdi-arrow-right-bold
                    </v-icon>

                  </v-btn>
                </template>

                <!-- Waypoints -->
                <div v-if="stage.type == 'Environment'">
                  <v-list-item
                    v-for="(waypoint, w) in stage.typeData.waypoints"
                    :key="w"
                    link
                    v-on:click="GoToStageAtWaypoint(stage,waypoint)"
                  >
                    <v-list-item-title v-text="waypoint.name" :style="(waypoint.id == activeWaypointid) ? 'color:blue' : ''"></v-list-item-title>
                  </v-list-item>
                </div>
              </v-list-group>
            </v-list-group>
        </v-list>
        
        
      </v-navigation-drawer>
</div>
</template>

<script>

import { mapState } from 'vuex'
import { mapActions } from 'vuex'
import { mapMutations} from 'vuex'
  export default {
    name: 'Template',
    components: {
    },
    props: {
    },
    computed: {

       ...mapState("sessionState",[
        "package",
        "currentStage",
        "activeWaypointid"
      ]),


    },

    mounted () {

     
    },
    data: () => ({

      listModel : null

    }),
    methods: {

       ...mapActions("sessionState",[
         "BeginStage"
      ]),
       ...mapMutations("sessionState", [
        "SetDesiredWaypoint",
      ]),

      GoToStage(stage)
      {
        this.BeginStage(stage);
      },
      GoToStageAtWaypoint(stage,waypoint)
      {
        this.SetDesiredWaypoint(waypoint.id);
        this.BeginStage(stage);
      },
      GoLeft()
      {
        let waypointIndex = 0;

        if(this.currentStage.type == "Environment")
        {
           for (let i = 0; i < this.currentStage.typeData.waypoints.length; i++) {
            const element = this.currentStage.typeData.waypoints[i];
            if(element.id == this.activeWaypointid)
            {
              waypointIndex = i;
              break;
            }
          }

          if(waypointIndex == 0)
          {
            let stageIndex = 0;
            for (let i = 0; i < this.package.stages.length; i++) {
              const element = this.package.stages[i];
              if(element.id == this.currentStage.id)
              {
                stageIndex = i;
                break;
              }
            }
            
            if(stageIndex > 0)
            {
              this.SetDesiredWaypoint(this.package.stages[stageIndex - 1].typeData.waypoints[this.package.stages[stageIndex - 1].typeData.waypoints.length -1].id);
              this.BeginStage(this.package.stages[stageIndex - 1]);
            }
          }
          else
          {
            this.SetDesiredWaypoint(this.currentStage.typeData.waypoints[waypointIndex - 1].id);
          }
        }
      },
      GoRight()
      {
        let waypointIndex = 0;

        if(this.currentStage.type == "Environment")
        {
           for (let i = 0; i < this.currentStage.typeData.waypoints.length; i++) {
            const element = this.currentStage.typeData.waypoints[i];
            if(element.id == this.activeWaypointid)
            {
              waypointIndex = i;
              break;
            }
          }

          if(waypointIndex + 1 == this.currentStage.typeData.waypoints.length)
          {
            let stageIndex = 0;
            for (let i = 0; i < this.package.stages.length; i++) {
              const element = this.package.stages[i];
              if(element.id == this.currentStage.id)
              {
                stageIndex = i;
                break;
              }
            }

            if(stageIndex + 1 < this.package.stages.length)
            {
              this.BeginStage(this.package.stages[stageIndex + 1]);
            }
          }
          else
          {
            this.SetDesiredWaypoint(this.currentStage.typeData.waypoints[waypointIndex + 1].id);
          }
        }
      },

    },
    watch: {
      
    }
  }
</script>
